// css =>
import "../../BaseStructure.css";
import Styled from "./MainPage.module.css";

import { useState, useEffect } from "react";

// componenets =>
import { confirmDialog } from "../../Components/PopUp/PopUp";
// import RialInput from "../../Components/RialInput/RialInput";
import Fotter from "../../Components/Fotter/Fotter";
import SpinnerBar from "../../Components/SpinnerBar/SpinnerBar";

// pictures =>
import FarazLogo from "../../Assets/Logo/Faraz.jpg";
import ProjectLogo from "../../Assets/Logo/Livora.jpeg";
import cardImage from '../../Assets/Pictures/کارت_ویزیت_لیوورا.jpg';

// api =>
import backEnd from "../../store/Api";

// analyzes =>
import bankAccountBalanceAnalyze from "../../store/AnalyzesAnswreLists/BankAccountBalanceAnalyze";


// scores =>
import ScoreList from "../../store/ScoresLists/ScoreList";
import haveVisaScores from "../../store/ScoresLists/HaveVisaList";
import haveHomeScores from "../../store/ScoresLists/HaveHomeList";
import alreadyJobScores from "../../store/ScoresLists/AlreadyJobList";
import { convertPersionToEnglish } from "../../store/PersionToEnglish";
import alreadyCitysScores from "../../store/ScoresLists/AlreadyCityList";
import haveRijectVisaScores from "../../store/ScoresLists/RijectVisaList";
import haveInsuranceScores from "../../store/ScoresLists/HaveInsuranceList";
import touristInvitationScores from "../../store/ScoresLists/TouristInvitationList";        
import businessInvitationScores from "../../store/ScoresLists/BusinessInvitationList";
import bankAccountBalanceScores from "../../store/ScoresLists/BankAccountBalanceList";

function MainPage() {

    const [isLoading, setIsLoading] = useState(false);
    const [nameInput, setNameInput] = useState(null);
    const [lastNameInput, setLastNameInput] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [ageInput, setAgeInput] = useState(null);
    const [genderInput, setGenderInput] = useState(null);
    const [maritalStatusInput, setMaritalStatusInput] = useState(null);
    const [haveChildInput, setHaveChildInput] = useState(null);
    const [haveRecivedVisaInput, setHaveRecivedVisaInput] = useState(null);
    const [alreadyJobsInput, setAlreadyJobsInput] = useState(null);
    const [insuranceHistoryInput, setInsuranceHistoryInput] = useState(null);
    const [bankAccountBalanceInput, setBankAccountBalanceInput] = useState(null);
    const [tripTypeInput, setTripTypeInput] = useState(null);
    const [requestedVisaTypeInput, setRequestedVisaTypeInput] = useState(null);
    const [haveBusinessInvitationInput, setHaveBusinessInvitationInput] = useState(null);
    const [haveTouristInvitationInput, setHaveTouristInvitationInput] = useState(null);
    const [rijectedVisaInput, setRijectedVisaInput] = useState(null);
    const [destinationCountryInput, setDestinationCountryInput] = useState(null);
    const [alreadyCityInput, setAlreadyCityInput] = useState(null);
    const [haveHomeInput, setHaveHomeInput] = useState(null);

    const [ageValue, setAgeValue] = useState("");

    useEffect( () => {
        setIsLoading(true);

        document.title = "فرم ارزیابی ویزا | لیوورا";

        setNameInput(document.querySelector('input[name="nameReceiver"]'));
        setLastNameInput(document.querySelector('input[name="lastNameReceiver"]'));
        setPhoneNumber(document.querySelector('input[name="phoneNumberReceiver"]'));
        setAgeInput(document.querySelector('input[name="AgeReceiver"]'));
        setGenderInput(document.querySelector('select[name="GenderReceiver"]'));
        setMaritalStatusInput(document.querySelector('select[name="MaritalStatusReceiver"]'));
        setHaveChildInput(document.querySelector('select[name="HaveChildReceiver"]'));
        setHaveRecivedVisaInput(document.querySelector('select[name="HaveRecivedVisaReceiver"]'));
        setAlreadyJobsInput(document.querySelector('select[name="AlreadyJobsReceiver"]'));
        setBankAccountBalanceInput(document.querySelector('input[name="BankBalanceReceiver"]'));
        setTripTypeInput(document.querySelector('select[name="TripTypeReceiver"]'));
        setInsuranceHistoryInput(document.querySelector('select[name="InsuranceHistoryReceiver"]'));
        setRequestedVisaTypeInput(document.querySelector('select[name="RequestedVisaTypeReceiver"]'));
        setRijectedVisaInput(document.querySelector('select[name="HaveRijectedVisaReceiver"]'));
        setDestinationCountryInput(document.querySelector('select[name="DestinationCountryReceiver"]'));
        setAlreadyCityInput(document.querySelector('select[name="AlreadyCityReceiver"]'));
        setHaveBusinessInvitationInput(document.querySelector('select[name="HaveBusinessInvitationReceiver"]'));
        setHaveTouristInvitationInput(document.querySelector('select[name="HaveTouristInvitationReceiver"]'));
        setHaveHomeInput(document.querySelector('select[name="HaveHomeReceiver"]'));
        setBankAccountBalanceInput(document.querySelector('select[name="BankBalanceReceiver"]'));

        setIsLoading(false);
    }, []);

    const elementBackgroundColorChanger = (e) => {
        if (e.target.value) {
            e.target.style.borderColor = "#96bcde";
            e.target.style.backgroundColor = "#c6ddec";
        } else {
            e.target.style.backgroundColor = "white";
            e.target.style.borderColor = "#d3d2d3";
        }
    };

    const invitaionStatusChanger = (e) => {
        if (e.target.value == 0) {
            e.target.style.borderColor = "#96bcde";
            e.target.style.backgroundColor = "#c6ddec";

            haveBusinessInvitationInput.value = "false";
            haveBusinessInvitationInput.style.display = 'none';
            haveTouristInvitationInput.style.display = 'inline-block';
        } else if (e.target.value == 1 || e.target.value == 2) {
            e.target.style.borderColor = "#96bcde";
            e.target.style.backgroundColor = "#c6ddec";

            haveTouristInvitationInput.value = "false";
            haveTouristInvitationInput.style.display = 'none';
            haveBusinessInvitationInput.style.display = 'inline-block';
        } else {
            e.target.style.backgroundColor = "white";
            e.target.style.borderColor = "#d3d2d3";
        }
    };

    const handleAgeValue = (e) => {
        let v = e.target.value;

        if (v === "") {
            setAgeValue("");

            e.target.style.backgroundColor = "white";
            e.target.style.borderColor = "#d3d2d3";
            
            return;
        } else {
            e.target.style.borderColor = "#96bcde";
            e.target.style.backgroundColor = "#c6ddec";
        }

        if (!/^\d+$/.test(v)) return;

        if (Number(v) > 100) return;

        setAgeValue(v);
    };

    const haveChildStatusChanger = (e) => {
        haveChildInput.value = "";

        if (e.target.value == "SINGLE") {
            haveChildInput.value = "false";
            haveChildInput.style.display = 'none';

            e.target.style.borderColor = "#96bcde";
            e.target.parentElement.style.width = "89%";
            e.target.style.backgroundColor = "#c6ddec";
        } else {
            e.target.parentElement.style.width = "43.8%";

            haveChildInput.style.display = 'inline-block';
            haveChildInput.style.borderColor = "#96bcde";
            haveChildInput.style.backgroundColor = "#c6ddec";
        }
    };

    
    async function Analyst() {
        const analyzeAnswre = [];
        let intUserAge = Number(ageInput.value);

        analyzeAnswre.push("\n\n سند ملکی:");
        analyzeAnswre.push("همراه عزیز لیوورا توجه داشته باشید داشتن اموال غیرمنقول از چندین نظر مهم است از جمله این موارد : \n\
                    1داشتن سند ملکی نشان دهنده تمکن مالی شماست \n\
                    2-اموال غیر منقول به نوعی ایجاد وابستگی اقتصادی با کشور مادر می نمایند و ریسک احتمال مهاجرت برای سفارت را کمتر می کند \n\
                    3-داشتن اموال غیر منقول در صورت عدم ارائه تمکن بانکی با موجوی  کافی می تواند به نوعی باعث پوشش این موضوع و رفع ایراد وارده به تمکن مالی شما گردد . \n\
                    4-وجود اموال غیر منقول در کنار تمکن بانکی بالا می تواند احتمال ریسک پول شویی برای سفارت را تا حدود زیادی کاهش دهد چون تمکن بانکی بالا بدون داشتن اسناد ملکی از نظر سفارت ریسک مهاجرت یا احتمال وجود پول کثیف را افزایش می دهد . \n\
                    5-دارا بودن اموال غیر منقول می تواند موجب اثبات اصالت گواهی شغلی شما و میزان موفقیت شما در این شغل باشد \n\
                    توجه داشته باشید بسته به میزان سن شما داشتن سند ملکی امتیاز مثبت و نداشتن آن امتیاز منفی است مثلا شخصی که حدود 50 سال سن دارد نداشتن یک خانه برای ایشان می تواند امتیاز منفی داشته باشد و همچنانچه داشتن یک ملک بزرگ برای فرد جوان 20 ساله ممکن است موجب بروز ریسک احساس عدم داشتن اصالت و سلامت سند ارائه شده به سفارت داشته باشد . چون از نظر سفارت در چنین سنی امکان خرید ملک برای یک جوان ممکن نیست مگر آنکه برای نحوه به دست آوردن آن ، دلایل مشخص به سفارت ارائه دهید ");

        analyzeAnswre.push("\n\n محل سکونت شما:");
        analyzeAnswre.push("همراه عزیز لیوورا اینکه در چه شهری ساکن هستید در خصوص اخذ ویزا تاثیر گذاری زیادی ندارد اما برخی از استان ها مثل خوزستان ، فارس ، تهران ، کرمانشاه ، کردستان تعداد درخواست کننده بیشتری برای مهاجرت دارند و عموم سفارت های اروپایی از این موضوع اصلاع کامل دارند لذا با وسواس بیشتری پرونده های درخواست ویزای این افراد را بررسی می کنند اما برای از استان ها مثل آذربایجان غربی و شرقی ، قزوین ، خراسان ، اصفهان ، اراک ، اردبیل  به نسبت تعداد افرادی که به قصد مهاجرت از طریق پناهندگی یا با ورود به کشور هدف از طریق اخذ ویزای توریستی در کشور اقدام می کنند بسیار کمتر است و به همان نسبت تعداد گردشگر واقعی این استان ها نیز بیشتر است بنابراین سفارت در بررسی پرونده این افراد وسواس بالایی نخواهد داشت ، پرونده های ساکنین  استان هایی مانند مرکزی ، هرمزگان ، سیستان ، زنجان ، البرز و استان های شمالی کشور نیز به صورت نرمال مورد بررسی قرار می گیرند و نگاه مثبت یا منفی روی پرونده های این افراد از این لحاظ وجود ندارد");

        if (haveBusinessInvitationInput.value == "true") {
            analyzeAnswre.push("\n\n دعوت نامه تجاری معتبر:");
            analyzeAnswre.push("اما در مورد داشتن یک دعوت نامه معتبر تجاری ، اصولا دعوت نامه های تجاری به چند دست تقسیم می شوند دسته اول دعوت نامه های نمایشگاهی که عمدتا در قالب خرید تیکت نمایشگاهی ، سمینار یا جلسات آموزشی می باشد که شما با خرید بلیط ورودی از شرکت برگزار کننده همایش یا نمایشگاه دعوت نامه ای دریافت می کنید این دعوت نامه به جهت توجیح و دلیل سفر شما به کشور مقصد به شرطی که با گواهی شغلی شما منطبق باشد بسیار خوب است اما استاندارد های یک دعوت نامه ایده آل را ندارد . دسته دوم دعوت نامه ها از طرف شرکت های مختلف تولیدی یا خدماتی به نام شما یا شرکت شما از طرف اشخاص حقیقی یا حقوقی در آن کشور صادر می گردد . میزان اعتبار صادر کننده دعوت نامه رابطه مستقیمی با افزایش درصد اخذ ویزای شما خواهد داشت و این موضوع به تنهایی می تواند دلیل سفر شما به کشور هدف را توجیح و احتمال بازگشت شما به ایران را از نظر سفارت بسیار زیاد کند . دسته سوم دعوت نامه ها دعوت نامه های تجاری هستند که در آن شخص یا شرکت دعوت کننده کلیه هزینه های اقامت شما در کشور هدف را تقبل می کند و به نوعی شما را برای سفارت ضمانت می نماید این دعوت نامه به شرط اعتبار خوب دعوت کننده به شدت می تواند در صدور روادید برای شما موثر باشد در صورتی که دارای دعوت نامه تجاری معتبر هستید این موضوع علاوه بر داشتن امتیاز مثبت می تواند موجب پوشش نقصان احتمالی  تمکن مالی شما باشد.");
        }

        if (haveTouristInvitationInput.value == "true") {
            analyzeAnswre.push("\n\n دعوت نامه توریستی معتبر:");
            analyzeAnswre.push("دوست عزیزم اگر یکی از اعضا خانواده یا دوستان شما ، از شما به قصد بازدید یا حضور در مراسم خانوادگی مثل عروسی یا صرف زیارت  دعوت کرده اند تا در یکی از کشور های حوزه شنگن حضور یابد این موضوع می تواند برای شما امتیاز بسیار مثبتی باشد به شرط آنکه این دعوت نامه یک دعوت نامه رسمی باشد که مورد تائید نهاد های مرتبط در کشور هدف مثل شهرداری یا وزارت کشور یا وزارت امورخارجه قرار گرفته باشد شخص دعوت کننده اقامت و شهروندی کشور فوق را داشته باشد و از تمکن مالی لازم برای دعوت و پذیرایی از یک مهمان و پرداخت هزینه های جانبی مثل هزینه های بیمارستانی در صورت بیمار شدن شخص را داشته باشد . در صورت داشتن چنین دعوت نامه ای این موضوع می تواند به شدت موجب افزایش امتیاز مثبت شما در سفارت برای اخذ روادید گردد شما می توانید با ارائه مدارک به صورت منظم و دقیق احتمال صدور روادید برای خود را به شدت افزایش دهید.");
        }

        if (haveRecivedVisaInput.value == "true") {
            analyzeAnswre.push("\n\n ویزای شنگن:");
            analyzeAnswre.push("مهمترین سوالی که اساس و چارچوب نحوه بررسی درخواست ویزای شما را نزد کنسول یا افسر ویزا شکل می دهد پاسخ به این پرسش است آیا در صورت صدور روادید شخص گیرنده ویزا بعد از اتمام مدت اعتبار ویزا به کشور خود باز می گردد . حال فرض کنید شما در سه سال اخیر ویزای شنگن اخذ کرده اید و پس از انجام سفر به کشور بازگشته اید خوب این موضوع می تواند موجب دگرگونی بسیار مثبت در فرآیند بررسی مدارک شما باشد و حتی پوششی موثر و فراگیر در جهت رفع نواقص احتمالی پرونده شما به جز برنامه سفر باشد . بنابراین شما با داشتن ویزای شنگن به تنهایی 30 امتیاز مثبت دریافت می کنید که امتیاز بسیار خوبی است اما اتمام ماجرا نیست");
        }

        if (rijectedVisaInput.value == "true") {
            analyzeAnswre.push("\n\n ویزای ریجکتی:");
            analyzeAnswre.push("دوست عزیزم در حالت نرمال سفارت ها نسبت به صدور روادید برای ایرانی و افغانی ها به شدت سخت گیر هستند و همواره احتمال مهاجرت و عدم بازگشت مسافر را لحاظ می کنند اکنون شما در این شرایط دارای سابقه ریجکتی از حوزه شنگن حتی با حدود گذشت 5 سال هم هستید خوب این موضوه به شدت برای شما امتیاز منفی خواهد داشت . این موضوع زمانی منجر یه ریجکتی درخواست ویزای شما قطعی به یقین می شود که شما اطلاعات مندرج در فرم اپلیکیشن خود در فرم اپلیکیشن درخواست روادید قبلی را در خاطر نداشته باشید مثلا فراموش کرده باشید در فرم قبلی شغل ، ادرس محل کار و زندگی خود را چه ذکر کرده اید و در فرم جدید اطلاعات کاملا متناقضی ذکر کنید این تناقض برای شما سرنوشتی جز یک ریجکتی دیگر نخواهد داشت .حتی اگر مدارک بسیار معتبر و مستندی به سفارت ارائه دهید . بنابراین شما هم اکنون دارای امتیاز منفی بسیار موثر هستید");
        }

        analyzeAnswre.push("\n\n شغل شما:");
        switch(alreadyJobsInput.value) {
            case "0":
                analyzeAnswre.push("دوست عزیزم ، گواهی شغلی یکی از مهمترین اسنادی است که سفارت بر اساس این سند سوالات مختلف خود را پاسخ می دهد از جمله این سوالات : \n\
                            آیا متقاضی اخذ روادید درآمد ماهانه مناسبی برای انجام یک سفر پر هزینه به مقصد اروپا دارد ؟ \n\
                            آیا متقاضی اخذ روادید بواسطه داشتن شغل معتبر و پردرآمد در کشور خود ، نیاز به مهاجرت یا پناهنده شدن در کشورهای اروپایی را دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید به گونه ای است که حتی در صورت مهاجرت یا درخواست پناهندگی در کشور مطبوع سفارت این شغل مورد نیاز بازار کار آن کشور باشد ؟ \n\
                            آیا شغل متقاضی اخذ روادید تجاری با دعوت نامه ارسالی از کشور هدف  تطابق و هماهنگی کاملی  دارد ؟ \n\
                            آیا گردش بانکی و تمکن مالی ارائه شده از طرف متقاضی اخذ روادید با نوع شغل اعلامی و میزان سن ایشان تناسب دارد ؟ \n\
                            آیا سابقه بیمه ارائه شده با گواهی شغلی انطباق کامل دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید در لیست شغل های بلاک لیست سفارت یا تحریمی اتحادیه اروپا قرار دارد ؟ \n\
                            و ده ها سوال دیگر  \n\
                            \n\
                            دوست عزیز شما یک کارمند محترم هستید ، یک سفر 7 روزه اروپایی حداقل 3200 تا 4000 یورو برای هر شخص هزینه دارد که با در نظر گرفتن قیمت ارز حدود 500 تا 600 میلیون تومان این هزینه برآورد می گردد ، این مبلغ معادل حقوق چند ماه یک کارمند می باشد . که از نظر کاردار سفارت انجام چنین سفر پر هزینه ای برای یک کارمند معمولی منطقی نیست و شما در این بخش امتیاز منفی موثر دریافت خواهید کرد مگر انکه با ارائه سایر مدارک مکمل ، تمکن مالی خود را ثابت نمایید .");
                break;
            case "1":
                analyzeAnswre.push("دوست عزیزم ، گواهی شغلی یکی از مهمترین اسنادی است که سفارت بر اساس این سند سوالات مختلف خود را پاسخ می دهد از جمله این سوالات : \n\
                            آیا متقاضی اخذ روادید درآمد ماهانه مناسبی برای انجام یک سفر پر هزینه به مقصد اروپا دارد ؟ \n\
                            آیا متقاضی اخذ روادید بواسطه داشتن شغل معتبر و پردرآمد در کشور خود ، نیاز به مهاجرت یا پناهنده شدن در کشورهای اروپایی را دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید به گونه ای است که حتی در صورت مهاجرت یا درخواست پناهندگی در کشور مطبوع سفارت این شغل مورد نیاز بازار کار آن کشور باشد ؟ \n\
                            آیا شغل متقاضی اخذ روادید تجاری با دعوت نامه ارسالی از کشور هدف  تطابق و هماهنگی کاملی  دارد ؟ \n\
                            آیا گردش بانکی و تمکن مالی ارائه شده از طرف متقاضی اخذ روادید با نوع شغل اعلامی و میزان سن ایشان تناسب دارد ؟ \n\
                            آیا سابقه بیمه ارائه شده با گواهی شغلی انطباق کامل دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید در لیست شغل های بلاک لیست سفارت یا تحریمی اتحادیه اروپا قرار دارد ؟ \n\
                            و ده ها سوال دیگر \n\
                            \n\
                            دوست عزیز شما شغل شرافتمندی دارید اما مثلما درآمد ماهانه شما برای یک سفر 7 روزه به اروپا که حدود 400 تا 500 میلیون تومان هزینه دارد کافی نیست چرا که از نظر سفارت انجام چنین سفری که معادل چندین ماه حقوق شما می باشد معقول نیست . شما در این قسمت امتیاز موثر منفی خواهید داشت ");
                break;
            case "2":
            case "3":
                analyzeAnswre.push("دوست عزیزم ، گواهی شغلی یکی از مهمترین اسنادی است که سفارت بر اساس این سند سوالات مختلف خود را پاسخ می دهد از جمله این سوالات :\n\
                            آیا متقاضی اخذ روادید درآمد ماهانه مناسبی برای انجام یک سفر پر هزینه به مقصد اروپا دارد ؟ \n\
                            آیا متقاضی اخذ روادید بواسطه داشتن شغل معتبر و پردرآمد در کشور خود ، نیاز به مهاجرت یا پناهنده شدن در کشورهای اروپایی را دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید به گونه ای است که حتی در صورت مهاجرت یا درخواست پناهندگی در کشور مطبوع سفارت این شغل مورد نیاز بازار کار آن کشور باشد ؟ \n\
                            آیا شغل متقاضی اخذ روادید تجاری با دعوت نامه ارسالی از کشور هدف  تطابق و هماهنگی کاملی  دارد ؟ \n\
                            آیا گردش بانکی و تمکن مالی ارائه شده از طرف متقاضی اخذ روادید با نوع شغل اعلامی و میزان سن ایشان تناسب دارد ؟ \n\
                            آیا سابقه بیمه ارائه شده با گواهی شغلی انطباق کامل دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید در لیست شغل های بلاک لیست سفارت یا تحریمی اتحادیه اروپا قرار دارد ؟ \n\
                            و ده ها سوال دیگر \n\
                            \n\
                            دوست عزیز شما در رسته و شاخه های پزشکی در حال فعالیت هستید این شغل همواره مورد احترام تمام کشور های دنیا بوده است بالاخص کشور های اروپایی که همواره در این شغل با کمبود نیروی کار مواجه هستند مثلما هر چه سن شما در رشته های پزشکی بالاتر از 40 سال باشد دارای امتیاز مثبت بیشتری برای اخذ روادید خواهید بود ولی در رشته های پرستاری هر چه سن شما کمتر و نیروی جوانی باشید دارای امتیاز بیشتری خواهید بود . سعی کنید در ارائه میزان درآمد ماهیانه مبلغی بالاتر از 1500 یورو به سفارت ارائه دهید . مبالغ کمتر از 900 یا 800 یورو نیازمند ارائه مدارک مالی مکمل برای نشان دادن تمکن مالی شما برای انجام یک سفر گردشگری اروپایی خواهد بود");
                break;
            case "4":
                analyzeAnswre.push("دوست عزیزم ، گواهی شغلی یکی از مهمترین اسنادی است که سفارت بر اساس این سند سوالات مختلف خود را پاسخ می دهد از جمله این سوالات : \n\
                            آیا متقاضی اخذ روادید درآمد ماهانه مناسبی برای انجام یک سفر پر هزینه به مقصد اروپا دارد ؟ \n\
                            آیا متقاضی اخذ روادید بواسطه داشتن شغل معتبر و پردرآمد در کشور خود ، نیاز به مهاجرت یا پناهنده شدن در کشورهای اروپایی را دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید به گونه ای است که حتی در صورت مهاجرت یا درخواست پناهندگی در کشور مطبوع سفارت این شغل مورد نیاز بازار کار آن کشور باشد ؟ \n\
                            آیا شغل متقاضی اخذ روادید تجاری با دعوت نامه ارسالی از کشور هدف  تطابق و هماهنگی کاملی  دارد ؟ \n\
                            آیا گردش بانکی و تمکن مالی ارائه شده از طرف متقاضی اخذ روادید با نوع شغل اعلامی و میزان سن ایشان تناسب دارد ؟ \n\
                            آیا سابقه بیمه ارائه شده با گواهی شغلی انطباق کامل دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید در لیست شغل های بلاک لیست سفارت یا تحریمی اتحادیه اروپا قرار دارد ؟ \n\
                            و ده ها سوال دیگر \n\
                            \n\
                            دوست عزیز شما مالک یک واحد تولیدی هستید سفارت بر اساس پروانه بهره برداری ، جواز تاسیس \n\
                            ، مدارک ثبتی شرکت ، لیست بیمه کارکنان ، مفاصا حساب مالیاتی و سایر اسناد مالکیت به انضمام تمکن بانکی و گردش مالی شما ، میزان امتیاز مثبت شما را بررسی خواهد کرد اگر شما یک فرد کارآفرین که سنی زیر 40 سال دارد هستید باید دقت کنید که هر چه سن شما جوان تر باشد باید تمکن مالی معقول تری به سفارت ارائه دهید چون یک شخص با سن کم مثلما نمی تواند مجموعه بزرگی را تاسیس کند مگر آنکه این مجموعه یک هلدینگ خانوادگی باشد . شما با کمی دقت می توانید در این بخش امتیاز مطلوبی اخذ کنید .");
                break;
            case "5":
                analyzeAnswre.push("دوست عزیزم ، گواهی شغلی یکی از مهمترین اسنادی است که سفارت بر اساس این سند سوالات مختلف خود را پاسخ می دهد از جمله این سوالات : \
                            آیا متقاضی اخذ روادید درآمد ماهانه مناسبی برای انجام یک سفر پر هزینه به مقصد اروپا دارد ؟ \
                            آیا متقاضی اخذ روادید بواسطه داشتن شغل معتبر و پردرآمد در کشور خود ، نیاز به مهاجرت یا پناهنده شدن در کشورهای اروپایی را دارد ؟ \
                            آیا شغل متقاضی اخذ روادید به گونه ای است که حتی در صورت مهاجرت یا درخواست پناهندگی در کشور مطبوع سفارت این شغل مورد نیاز بازار کار آن کشور باشد ؟ \
                            آیا شغل متقاضی اخذ روادید تجاری با دعوت نامه ارسالی از کشور هدف  تطابق و هماهنگی کاملی  دارد ؟ \
                            آیا گردش بانکی و تمکن مالی ارائه شده از طرف متقاضی اخذ روادید با نوع شغل اعلامی و میزان سن ایشان تناسب دارد ؟ \
                            آیا سابقه بیمه ارائه شده با گواهی شغلی انطباق کامل دارد ؟ \
                            آیا شغل متقاضی اخذ روادید در لیست شغل های بلاک لیست سفارت یا تحریمی اتحادیه اروپا قرار دارد ؟ \
                            و ده ها سوال دیگر \
                            مدیر گرامی توانمندی مجموعه شما بر اساس مفاصا حساب بیمه تامین اجتماعی پرسنل ، مبلغ دارایی و مالیات بر درآمد پرداختی ، گردش حساب و موجودی بانکی و البته رسته شغلی شما مشخص می گردد بنابراین سعی کنید با ارائه مستندات بالقوه به صورت شفاف میزان درآمد خود برای سفارت را تعیین نمایید . در نظر داشته باشید انجام یک سفر به مقصد کشور های اروپایی روزانه حداقل بین ۱۸۰ تا ۵۰۰ یورو برای شما هزیته دارد لذا درآمد شما باید به گونه ای باشد که به راحتی بتوانید هزینه  این سفر را با پس انداز چند ماهه درآمد خود پرداخت نمایید و این موضوع مهمترین نقطه در بررسی های صورت گرفته کاردار سفارت خواهد بود . بنابریان به هر میزان که درآمد شما بیشتر باشد به همان میزان احتمال صدور روادید برای شما نیز بیشتر می گردد");
                break;
            case "6":
                analyzeAnswre.push("بازنشسته عزیز شما دارای مبلغ مشخصی از حقوق ماهیانه هستید قدر مسلم این مبلغ حقوق کفاف یک سفر اروپایی با حداقل هزینه روزانه ۲۰۰ تا ۵۰۰ یورو را نخواهد کرد قطع نظر از هزینه های بلیط هواپیما و صدور روادید ، شما می بایست  ضمن ارائه اسناد شغلی خود بواسطه ارائه مدارک مکمل مثل تمکن بانکی ، اموال غیر منقولی که در اجاره دارید و مدارک بورس و ... داشتن درآمد کافی برای انجام این سفر را ثابت نمایید");
                break;
            case "7":
                analyzeAnswre.push("دوست عزیزم ، گواهی شغلی یکی از مهمترین اسنادی است که سفارت بر اساس این سند سوالات مختلف خود را پاسخ می دهد از جمله این سوالات : \n\
                            آیا متقاضی اخذ روادید درآمد ماهانه مناسبی برای انجام یک سفر پر هزینه به مقصد اروپا دارد ؟ \n\
                            آیا متقاضی اخذ روادید بواسطه داشتن شغل معتبر و پردرآمد در کشور خود ، نیاز به مهاجرت یا پناهنده شدن در کشورهای اروپایی را دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید به گونه ای است که حتی در صورت مهاجرت یا درخواست پناهندگی در کشور مطبوع سفارت این شغل مورد نیاز بازار کار آن کشور باشد ؟ \n\
                            آیا شغل متقاضی اخذ روادید تجاری با دعوت نامه ارسالی از کشور هدف  تطابق و هماهنگی کاملی  دارد ؟ \n\
                            آیا گردش بانکی و تمکن مالی ارائه شده از طرف متقاضی اخذ روادید با نوع شغل اعلامی و میزان سن ایشان تناسب دارد ؟ \n\
                            آیا سابقه بیمه ارائه شده با گواهی شغلی انطباق کامل دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید در لیست شغل های بلاک لیست سفارت یا تحریمی اتحادیه اروپا قرار دارد ؟ \n\
                            و ده ها سوال دیگر \n\
                            \n\
                            دوست عزیز شما شغل مناسبی جهت ارائه به سفارت ندارید هر چند ممکن است تمکن بانکی و مالی زیادی داشته باشید اما داشتن یک شغل و اثبات درآمد ماهانه یا سالانه جز مهمترین مدارک لازم برای ارائه به سفارت است شما در این قسمت دارای امتیاز منفی موثر هستید");
                break;
            case "8":
                analyzeAnswre.push("دوست عزیزم ، گواهی شغلی یکی از مهمترین اسنادی است که سفارت بر اساس این سند سوالات مختلف خود را پاسخ می دهد از جمله این سوالات : \n\
                            آیا متقاضی اخذ روادید درآمد ماهانه مناسبی برای انجام یک سفر پر هزینه به مقصد اروپا دارد ؟ \n\
                            آیا متقاضی اخذ روادید بواسطه داشتن شغل معتبر و پردرآمد در کشور خود ، نیاز به مهاجرت یا پناهنده شدن در کشورهای اروپایی را دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید به گونه ای است که حتی در صورت مهاجرت یا درخواست پناهندگی در کشور مطبوع سفارت این شغل مورد نیاز بازار کار آن کشور باشد ؟ \n\
                            آیا شغل متقاضی اخذ روادید تجاری با دعوت نامه ارسالی از کشور هدف  تطابق و هماهنگی کاملی  دارد ؟ \n\
                            آیا گردش بانکی و تمکن مالی ارائه شده از طرف متقاضی اخذ روادید با نوع شغل اعلامی و میزان سن ایشان تناسب دارد ؟ \n\
                            آیا سابقه بیمه ارائه شده با گواهی شغلی انطباق کامل دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید در لیست شغل های بلاک لیست سفارت یا تحریمی اتحادیه اروپا قرار دارد ؟ \n\
                            و ده ها سوال دیگر \n\
                            \n\
                            دوست عزیز شما یک دانشجو هستید و مثلما درآمدی برای انجام یک سفرپر هزینه اروپایی ندارید اصولا شما در این قسمت دارای امتیاز منفی موثر هستید مگر آنکه قیم و ولی شما در سفر شما را همراهی کنند و گواهی شغلی و تمکن مالی ایشان بتواند شما را نیز ساپورت کند");
                break;
            case "9":
                analyzeAnswre.push("دوست عزیزم ، گواهی شغلی یکی از مهمترین اسنادی است که سفارت بر اساس این سند سوالات مختلف خود را پاسخ می دهد از جمله این سوالات : \n\
                            آیا متقاضی اخذ روادید درآمد ماهانه مناسبی برای انجام یک سفر پر هزینه به مقصد اروپا دارد ؟ \n\
                            آیا متقاضی اخذ روادید بواسطه داشتن شغل معتبر و پردرآمد در کشور خود ، نیاز به مهاجرت یا پناهنده شدن در کشورهای اروپایی را دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید به گونه ای است که حتی در صورت مهاجرت یا درخواست پناهندگی در کشور مطبوع سفارت این شغل مورد نیاز بازار کار آن کشور باشد ؟ \n\
                            آیا شغل متقاضی اخذ روادید تجاری با دعوت نامه ارسالی از کشور هدف  تطابق و هماهنگی کاملی  دارد ؟ \n\
                            آیا گردش بانکی و تمکن مالی ارائه شده از طرف متقاضی اخذ روادید با نوع شغل اعلامی و میزان سن ایشان تناسب دارد ؟ \n\
                            آیا سابقه بیمه ارائه شده با گواهی شغلی انطباق کامل دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید در لیست شغل های بلاک لیست سفارت یا تحریمی اتحادیه اروپا قرار دارد ؟ \n\
                            و ده ها سوال دیگر \n\
                            \n\
                            دوست عزیزم شما یک وکیل هستید و این شغل در سرتاسر جهان دارای اعتبار و احترام هست اما مثلما جز شغل هایی نیست که در کشور هدف مورد نیاز بازار کار آن کشور باشد اما کاردار سفارت به دلیل شغل خوب شما و جایگاه و منزلت اجتماعی در داخل ایران امتیاز مثبتی به شما خواهد داد این امتیاز هز چه سن شما از 40 سال فراتر رود بیشتر و هر میزان شما وکیل جوانی باشید کمتر خواهد بود میزان گردش حساب بانکی و تمکن مالی شما ، تاثیری زیادی براثبات میزان تخصص و درآمد ماهانه شما خواهد داشت ");
                break;
            case "10":
                analyzeAnswre.push("دوست عزیزم ، گواهی شغلی یکی از مهمترین اسنادی است که سفارت بر اساس این سند سوالات مختلف خود را پاسخ می دهد از جمله این سوالات : \
                            آیا متقاضی اخذ روادید درآمد ماهانه مناسبی برای انجام یک سفر پر هزینه به مقصد اروپا دارد ؟ \
                            آیا متقاضی اخذ روادید بواسطه داشتن شغل معتبر و پردرآمد در کشور خود ، نیاز به مهاجرت یا پناهنده شدن در کشورهای اروپایی را دارد ؟ \
                            آیا شغل متقاضی اخذ روادید به گونه ای است که حتی در صورت مهاجرت یا درخواست پناهندگی در کشور مطبوع سفارت این شغل مورد نیاز بازار کار آن کشور باشد ؟ \
                            آیا شغل متقاضی اخذ روادید تجاری با دعوت نامه ارسالی از کشور هدف  تطابق و هماهنگی کاملی  دارد ؟ \
                            آیا گردش بانکی و تمکن مالی ارائه شده از طرف متقاضی اخذ روادید با نوع شغل اعلامی و میزان سن ایشان تناسب دارد ؟ \
                            آیا سابقه بیمه ارائه شده با گواهی شغلی انطباق کامل دارد ؟ \
                            آیا شغل متقاضی اخذ روادید در لیست شغل های بلاک لیست سفارت یا تحریمی اتحادیه اروپا قرار دارد ؟ \
                            و ده ها سوال دیگر \
                            مهندس عزیز شما یک شغل خوب و معتبر دارید اما میزان درآمد این شغل می تواند بسیار متفاوت برای اشخاص مختلف باشد . در نظر داشته باشید متوسط انجام یک سفر اروپایی به جز هزینه بلیط هواپیما روزانه بین ۱۵۰ تا ۴۰۰ یورو برای هر شخص هزینه خواهد داشت با در نظر گرفتن قیمت یورو حدود دویست هزار تومان یعنی اگر شما یک سفر هفت روزه را تجربه می کنید مبلغی در حدود متوسط پانصد میلیون تومان هزینه سفر به جز هزینه بلیط هواپیما و هزینه های جانبی خواهید داشت . میزان درآمد شما باید به گونه ای باشد که انجام چنین سفر پر هزینه ای را توجیح کند یعنی بتوانید با درآمد دو تا سه ماه چنین سفری را تجربه کنید یا درآمد های مکمل شغل خود به سفارت نشان دهید برای سفارت بسیار مهم هست شغل شما کفاف هزینه های جنینی سفری را می کند");
                break;
            case "11":
                analyzeAnswre.push("دوست عزیزم ، گواهی شغلی یکی از مهمترین اسنادی است که سفارت بر اساس این سند سوالات مختلف خود را پاسخ می دهد از جمله این سوالات : \n\
                            آیا متقاضی اخذ روادید درآمد ماهانه مناسبی برای انجام یک سفر پر هزینه به مقصد اروپا دارد ؟ \n\
                            آیا متقاضی اخذ روادید بواسطه داشتن شغل معتبر و پردرآمد در کشور خود ، نیاز به مهاجرت یا پناهنده شدن در کشورهای اروپایی را دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید به گونه ای است که حتی در صورت مهاجرت یا درخواست پناهندگی در کشور مطبوع سفارت این شغل مورد نیاز بازار کار آن کشور باشد ؟ \n\
                            آیا شغل متقاضی اخذ روادید تجاری با دعوت نامه ارسالی از کشور هدف  تطابق و هماهنگی کاملی  دارد ؟ \n\
                            آیا گردش بانکی و تمکن مالی ارائه شده از طرف متقاضی اخذ روادید با نوع شغل اعلامی و میزان سن ایشان تناسب دارد ؟ \n\
                            آیا سابقه بیمه ارائه شده با گواهی شغلی انطباق کامل دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید در لیست شغل های بلاک لیست سفارت یا تحریمی اتحادیه اروپا قرار دارد ؟ \n\
                            و ده ها سوال دیگر \n\
                            \n\
                            شما یک بازاری با نوع شغل پردرآمد هستید . اثبات این موضوع که تا چه میزان در شغل خود موفق هستید علاوه بر داشتن پروانه کسب قابل استعلام به انضمام بیمه تامین اجتماعی ، با ارائه و بررسی تمکن مالی و گردش حساب شما خواهد بود . در نظر داشته باشید این مبلغ باید تناسبی هماهنگ با میزان سن شما و مدتی که در این شغل در حال فعالیت هستید نیز داشته باشد . تمکن مالی و گردش حساب بانکی در این نوع شغل ها با وسواس خاص ازبانک استعلام می گردد");
                break;
            case "12":
                analyzeAnswre.push("دوست عزیزم ، گواهی شغلی یکی از مهمترین اسنادی است که سفارت بر اساس این سند سوالات مختلف خود را پاسخ می دهد از جمله این سوالات : \n\
                            آیا متقاضی اخذ روادید درآمد ماهانه مناسبی برای انجام یک سفر پر هزینه به مقصد اروپا دارد ؟ \n\
                            آیا متقاضی اخذ روادید بواسطه داشتن شغل معتبر و پردرآمد در کشور خود ، نیاز به مهاجرت یا پناهنده شدن در کشورهای اروپایی را دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید به گونه ای است که حتی در صورت مهاجرت یا درخواست پناهندگی در کشور مطبوع سفارت این شغل مورد نیاز بازار کار آن کشور باشد ؟ \n\
                            آیا شغل متقاضی اخذ روادید تجاری با دعوت نامه ارسالی از کشور هدف  تطابق و هماهنگی کاملی  دارد ؟ \n\
                            آیا گردش بانکی و تمکن مالی ارائه شده از طرف متقاضی اخذ روادید با نوع شغل اعلامی و میزان سن ایشان تناسب دارد ؟ \n\
                            آیا سابقه بیمه ارائه شده با گواهی شغلی انطباق کامل دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید در لیست شغل های بلاک لیست سفارت یا تحریمی اتحادیه اروپا قرار دارد ؟ \n\
                            و ده ها سوال دیگر \n\
                            \n\
                            دوست عزیز شما یک بازاری هستید قدر مسلم پروانه کسب شما به صورت انلاین استعلام می گردد و نسبت به سن شما و مدت بیمه تامین اجتماعی شما تجربه شما مشخص می گردد این مدت رابطه مستقیمی با میزان تمکن مالی و گردش بانکی شما در محاسبه سفارت برای میزان موفقیت شما در این شغل خواهد داشت . دقت کنید شما باید درآمد بالای 100 میلیون تومان حداقل به سفارت نشان دهید");
                break;
            case "13":
                analyzeAnswre.push("دوست عزیزم ، گواهی شغلی یکی از مهمترین اسنادی است که سفارت بر اساس این سند سوالات مختلف خود را پاسخ می دهد از جمله این سوالات : \n\
                            آیا متقاضی اخذ روادید درآمد ماهانه مناسبی برای انجام یک سفر پر هزینه به مقصد اروپا دارد ؟ \n\
                            آیا متقاضی اخذ روادید بواسطه داشتن شغل معتبر و پردرآمد در کشور خود ، نیاز به مهاجرت یا پناهنده شدن در کشورهای اروپایی را دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید به گونه ای است که حتی در صورت مهاجرت یا درخواست پناهندگی در کشور مطبوع سفارت این شغل مورد نیاز بازار کار آن کشور باشد ؟ \n\
                            آیا شغل متقاضی اخذ روادید تجاری با دعوت نامه ارسالی از کشور هدف  تطابق و هماهنگی کاملی  دارد ؟ \n\
                            آیا گردش بانکی و تمکن مالی ارائه شده از طرف متقاضی اخذ روادید با نوع شغل اعلامی و میزان سن ایشان تناسب دارد ؟ \n\
                            آیا سابقه بیمه ارائه شده با گواهی شغلی انطباق کامل دارد ؟ \n\
                            آیا شغل متقاضی اخذ روادید در لیست شغل های بلاک لیست سفارت یا تحریمی اتحادیه اروپا قرار دارد ؟ \n\
                            و ده ها سوال دیگر \n\
                            \n\
                            دوست عزیزم شما یک بازاری و کاسب محلی هستید مطمئن شوید می توانید درآمد ماهانه بیش از 150 میلیون تومان به سفارت ارائه دهید در غیر اینصورت نگاه سفارت به شغل شما برای صدور روادید متزلزل خواهد بود ");
                break;
        }

        analyzeAnswre.push("\n\n سابقه بیمه شما:");
        if (insuranceHistoryInput.value == "true") {
            analyzeAnswre.push("همراه عزیز لوورا ، سابقه بیمه جز مدارک مکملی است که تاثیر مستقیمی روی اثبات صحت و سلامت اسناد گواهی شغلی شما از نظر سفارت دارد علاوه بر آن مدت زمان این سابقه بیمه وابستگی شما به شغل مورد نظر را نشان می دهد . داشتن سابقه بیمه مرتبط با گواهی شغلی دارای امتیاز مثبت مضاعف روی گواهی شغلی شما خواهد داشت");
        } else {
            analyzeAnswre.push("همراه عزیز لوورا ، سابقه بیمه جز مدارک مکملی است که تاثیر مستقیمی روی صحت و سلامت اسناد گواهی شغلی شما از نظر سفارت دارد علاوه بر آن مدت زمان این سابقه بیمه وابستگی شما به شغل مورد نظر را نشان می دهد . اگر سابقه بیمه مرتبط با شغل ارائه شده به سفارت را ندارید علاوه بر اینکه در این قسمت امتیاز منفی خواهید داشت این موضوع تاثیر مستقیمی در اعتبار و اصالت گواهی شغلی شما نیز خواهد داشت.");
        }

        for (let row of bankAccountBalanceAnalyze) {
            if (intUserAge >= row.min && intUserAge < row.max && alreadyJobsInput.value == row.jobIndex) {
                analyzeAnswre.push("\n\n تمکن مالی شما:");
                analyzeAnswre.push(row.result);
                break;
            }
        }

        analyzeAnswre.push("\n\n درباره کشور مقصد شما:");
        switch(destinationCountryInput.value) {
            case "0":
            case "1":
            case "2":
            case "3":
            case "5":
            case "14":
            case "16":
                analyzeAnswre.push("دوست عزیزم کشوری که شما برای مسافرت یا مهاجرت انتخاب کرده اید عمدتا یک کشور با سیاست جذب گردشگر یا به اصطلاح یک کشور توریستی نیست لذا برای اخذ ویزای توریستی سیاست این کشور ها بر پایه اخذ توضیحات کافی بر مبنای شفافیت توجیح و دلیل سفر است که عموما با ارائه دعوت نامه  دیدار یا دعوت نامه تجاری معتبر این موضوع برای سفارت میسر می گردد . بنابراین اگر قصد سفر به این کشور ها را دارید و دعوت نامه معتبر نیز ندارید به شما پیشنهاد می کنیم مقصد اول خود برای ورود به حوزه شنگن را تغییر دهید");
                break;

            case "4":
            case "8":
            case "6":
            case "9":
            case "15":
            case "12":
                analyzeAnswre.push("خوب کشوری که شما به قصد سفر آن را انتخاب کرده اید جز کشورهای با جاذبه گردشگری است و سیاست این کشور بر مبنای جذب گردشگر است لذا فرآیند صدور روادید در این کشور نسبت به بسیاری از کشور های دیگر اتحادیه اروپا آسانتر است  البته توجه داشته باشید منظور ما این نیست که این کشور به راحتی روادید شما رو صادر خواهد کرد بلکه نسبت صدور روادید نسبت به سایر کشور های اتحادیه اروپا در وضعیت مطلوب تری قرار دارد");
                break;
        }

        return analyzeAnswre.join("\n\n");
    }

    async function VisaAssessor() {

        setIsLoading(true);

        if (!ageInput.value || !genderInput.value || !maritalStatusInput.value || !haveChildInput.value || !haveRecivedVisaInput.value || !alreadyJobsInput.value || !insuranceHistoryInput.value || !bankAccountBalanceInput.value || !requestedVisaTypeInput.value || !rijectedVisaInput.value || !destinationCountryInput.value || !alreadyCityInput.value || !haveHomeInput.value || !tripTypeInput.value) {
            return confirmDialog("لطفا تمامی فیلد ها را مقدار دهی کنید", 'error');
        }

        let score = 0;
        let message = "";
        let status = "info";
        let fullAnalyze = "";
        let resultTextColor = "";
        let messageScoreRage = "";

        const Answers = {
            name: nameInput.value,
            lastName: lastNameInput.value,
            phoneNumber: phoneNumber.value,
            age: Number(ageInput.value),
            genderIndex: String(genderInput.value),
            maritalStatus: String(maritalStatusInput.value),
            haveChild: haveChildInput.value === "true",
            haveRecivedVisa: haveRecivedVisaInput.value === "true",
            jobIndex: Number(alreadyJobsInput.value),
            haveInsurance: insuranceHistoryInput.value === "true",
            requestedVisaType: Number(requestedVisaTypeInput.value),
            haveBusinessInvitation: haveBusinessInvitationInput.value === "true",
            haveTouristInvitation: haveTouristInvitationInput.value === "true",
            rijectedVisa: rijectedVisaInput.value === "true",
            countryIndex: Number(destinationCountryInput.value),
            alreadyCity: Number(alreadyCityInput.value),
            haveHome: haveHomeInput.value === "true",
            userPrice: Number(bankAccountBalanceInput.value),
            userTripType: Number(tripTypeInput.value)
        };

        for (let row of ScoreList) {
            if (Answers.age >= row.min && Answers.age < row.max && Answers.userTripType == row.tripTypeIndex) {
                score += row.score;
            }
        }

        for (let row of haveRijectVisaScores) {
            if (Answers.age >= row.min && Answers.age < row.max && Answers.rijectedVisa == row.isRiject) {
                score += row.score;
            }
        }

        for (let row of haveVisaScores) {
            if (Answers.age >= row.min && Answers.age < row.max && Answers.haveRecivedVisa == row.haveVisa) {
                score += row.score;
            }
        }

        for (let row of haveHomeScores) {
            if (Answers.age >= row.min && Answers.age < row.max && Answers.haveHome == row.haveHome) {
                score += row.score;
            }
        }

        score += alreadyCitysScores[Answers.alreadyCity];

        for (let row of haveInsuranceScores) {
            if (Answers.age >= row.min && Answers.age < row.max && Answers.haveInsurance == row.haveInsurance) {
                score += row.score;
            }
        }

        for (let row of alreadyJobScores) {
            if (Answers.age >= row.min && Answers.age < row.max && Answers.jobIndex == row.jobIndex) {
                score += row.score;
            }
        }

        for (let row of bankAccountBalanceScores) {
            if (Answers.age >= row.min && Answers.age < row.max && Answers.jobIndex == row.jobIndex && Answers.userPrice >= row.minPrice && Answers.userPrice < row.maxPrice) {
                score += row.score;
            }
        }

        for (let row of touristInvitationScores) {
            if (Answers.haveTouristInvitation == row.haveInvitation) {
                score += row.score;
            }
        }

        for (let row of businessInvitationScores) {
            if (Answers.haveBusinessInvitation == row.haveInvitation) {
                score += row.score;
            }
        }

        if ( score <= 20 ) {
            resultTextColor = "red";

            messageScoreRage = "0-20";
            // message = "دوست من متاسفانه شما در محدوده بسیار پر ریسک برای اخذ ویزا قرار دارید احتمال صدور روادید برای شما بسیار کم است جهت دریافت آنالیز امتیاز خود کد رهگیری پیامکی خود را در دوم وارد نمایید";

            message = `پرونده شما نیاز به تقویت دارد

                در حال حاضر شانس دریافت ویزا پایین است، اما این پایان راه نیست. لیوورا کنار شماست تا مسیر بهتری برای بهبود پرونده‌تان پیشنهاد دهد.
                برای مشاهده تحلیل کامل، کد پیامک‌شده را در لینک بالا وارد کنید.
                برای ارتباط سریع‌تر، تماس مستقیم بگیرید یا کارت ویزیت لیوورا را دانلود و شماره‌ها را در گوشی خود ذخیره کنید.

                <a href="${ cardImage }" download="کارت_ویزیت_لیوورا.jpg" style="color:#007bff; text-decoration:underline;">دانلود کارت ویزیت</a>
                <a href="https://livoragroup.ir/analys" target="_blank" style="color: #007bff; text-decoration: underline;">livoragroup.ir/analys :لینک آنالیز</a>

                تماس: 0218899078 - 02188997078 - 02122386062 - 09002799993`;
        } else if ( score > 20 && score <= 40 ) {
            resultTextColor = "red";

            messageScoreRage = "20-40";
            // message = "دوست من شما در محدوده پر ریسک با احتمال بالای ریجکتی قرار گرفته اید به شما پیشنهاد می کنم ابتدا با وارد نمودن کد اشتراک خود در لینک دوم  آنالیز نقاط قوت و ضعف خود رو دریافت نمایید";

            message = `پرونده شما پرریسک است

                پرونده شما شانس اقدام دارد، اما هنوز نیاز به بررسی و تقویت تخصصی دارد. با راهنمایی لیوورا می‌توانید ریسک پرونده را کمتر کنید.
                کد پیامک‌شده را وارد کنید و تحلیل کامل را ببینید.
                برای دریافت مشاوره سریع، تماس بگیرید یا کارت ویزیت لیوورا را دانلود و اطلاعات تماس را ذخیره کنید.

                <a href="${ cardImage }" download="کارت_ویزیت_لیوورا.jpg" style="color:#007bff; text-decoration:underline;">دانلود کارت ویزیت</a>
                <a href="https://livoragroup.ir/analys" target="_blank" style="color: #007bff; text-decoration: underline;">livoragroup.ir/analys :لینک آنالیز</a>

                تماس: 0218899078 - 02188997078 - 02122386062 - 09002799993`;
        } else if ( score > 40 && score <= 60 ) {
            resultTextColor = "red";

            messageScoreRage = "40-60";
            // message = "دوست من شما می توانید با مشاوره صحیح و ارائه مدارک مکمل امتیاز خود رو به حداقل ۸۰ امتیاز برای اخذ روادید افزایش دهید و آنالیز نقاط قوت و ضعف  ویژگی پرونده خود را دریافت کنید";

            message = `وضعیت پرونده شما امیدوارکننده است

                پرونده شما در شرایط خوبی قرار دارد و با چند اقدام هوشمندانه، می‌توان شانس موفقیت را بیشتر کرد. لیوورا این مسیر را برای شما حرفه‌ای‌تر می‌کند.
                برای دیدن تحلیل کامل، کد ارسال‌شده را وارد کنید.
                برای ادامه مسیر، تماس مستقیم بگیرید یا کارت ویزیت لیوورا را دانلود و شماره‌ها را در گوشی خود ثبت کنید.

                <a href="${ cardImage }" download="کارت_ویزیت_لیوورا.jpg" style="color:#007bff; text-decoration:underline;">دانلود کارت ویزیت</a>
                <a href="https://livoragroup.ir/analys" target="_blank" style="color: #007bff; text-decoration: underline;">livoragroup.ir/analys :لینک آنالیز</a>

                تماس: 0218899078 - 02188997078 - 02122386062 - 09002799993`;
        } else if ( score > 60 && score <= 80 ) {
            resultTextColor = "orange";

            messageScoreRage = "60-80";
            // message = "دوست من شما در شرایط خوب برای اخذ روادید قرار دارید با یک مشاوره صحیح و افزایش امتیاز خود ، درصد ریسک عدم صدور روادید رو تا حد امکان کم کنید شما با وارد کردن کد اشتراک در لینک دوم می توانید آنالیز نقاط قوت و ضعف خود را دریافت نمایید";

            message = `پرونده شما در وضعیت بسیار خوبی است

                تبریک! پرونده شما شانس بالایی برای دریافت ویزا دارد. با همراهی لیوورا می‌توانید این موقعیت خوب را به بهترین نتیجه تبدیل کنید.
                کد پیامک‌ شده را وارد کنید و تحلیل اختصاصی خود را ببینید.
                برای شروع اقدام، تماس بگیرید یا کارت ویزیت لیوورا را دانلود و اطلاعات تماس را در گوشی خود ذخیره کنید.

                <a href="${ cardImage }" download="کارت_ویزیت_لیوورا.jpg" style="color:#007bff; text-decoration:underline;">دانلود کارت ویزیت</a>
                <a href="https://livoragroup.ir/analys" target="_blank" style="color: #007bff; text-decoration: underline;">livoragroup.ir/analys :لینک آنالیز</a>

                تماس: 0218899078 - 02188997078 - 02122386062 - 09002799993`;
        } else {
            resultTextColor = "green";

            messageScoreRage = "100";
            message = `دوست من، شما در شرایط ایده‌آل برای اخذ روادید قرار دارید.

                با یک مشاوره صحیح و برنامه سفر درست، می‌توانید شانس بالایی برای اخذ روادید داشته باشید.
                شما می‌توانید با وارد کردن کد اشتراک خود در لینک دوم، آنالیز امتیاز و نقاط ضعف و قوت خود را دریافت نمایید.
                
                <a href="${ cardImage }" download="کارت_ویزیت_لیوورا.jpg" style="color:#007bff; text-decoration:underline;">دانلود کارت ویزیت</a>
                <a href="https://livoragroup.ir/analys" target="_blank" style="color: #007bff; text-decoration: underline;">livoragroup.ir/analys :لینک آنالیز</a>`;
        }

        fullAnalyze = await Analyst();

        let Token = '';
        await backEnd.get("/users/get_csrf_token/").then((result) => {
            Token = result.data.csrftoken;
        }).catch((error) => {
            console.log(error);
        })

        await backEnd.post("/users/profile-create-or-update/", {
            phone_number: convertPersionToEnglish(Answers.phoneNumber),
            name: Answers.name,
            last_name: Answers.lastName,
            age: Answers.age,
            gender: Answers.genderIndex,
            marital_status: Answers.maritalStatus,
            have_child: Answers.haveChild,
            have_visa: Answers.haveRecivedVisa,
            reject_visa: Answers.rijectedVisa,
            job: Answers.jobIndex,
            insurance_history: Answers.haveInsurance,
            bank_account_balance: Answers.userPrice,
            travel_type: Answers.userTripType,
            request_visa_type: Answers.requestedVisaType,
            destination_country: Answers.countryIndex,
            already_city: Answers.alreadyCity,
            have_property: Answers.haveHome,
            score: score,
            score_tittle: messageScoreRage,
            analyze: fullAnalyze
        }, {
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": Token,
            }
        }).then((result) => {
            status = 'info';
        }).catch((error) => {
            score = 'خطا';
            status = "error";
            resultTextColor = "red";

            message = error.message;
            message += '!لطفا دقایقی دیگر مجددا تلاش کنید';
        })

        setIsLoading(false);

        // const showDialog = await confirmDialog(message, status, resultTextColor, `نتیجه ارزیابی شما: ${score}`);
        const showDialog = await confirmDialog(
            message,
            status,
            `نتیجه ارزیابی شما: ${score}`,
            resultTextColor,
            '#1f2937'
        );

        if (showDialog) {
            window.location.reload();
        }
    }

    return (
        <>
            {
                isLoading ? <SpinnerBar /> : (
                    <>
                        <div className="row" id={ Styled.FormFrame }>

                            <br /><br />

                            <div className="col-12" id={ Styled.FistTittleFrame }>
                                <img src={ ProjectLogo } alt="Livora" style={{ width: '20%', float: 'left' }} />
                                <img src={ FarazLogo } alt="Livora" style={{ width: '20%', float: 'left' }} />
                            </div>

                            <div className={`row ${ Styled.FormPartsFrame }`} style={{ marginTop: '3%' }}>
                                <div className="col-1"><hr /></div>
                                <div className="col-2">
                                    <h3>فرم ارزیابی</h3>
                                </div>
                                <div className="col-9"><hr /></div>
                            </div>

                            <div className={`col-5 ${ Styled.InputsFrame, Styled.FullNameInputs }`}>
                                <input type="text" placeholder="نام" name="nameReceiver" onChange={elementBackgroundColorChanger} />
                            </div>
                            <div className={`col-5 ${ Styled.InputsFrame, Styled.FullNameInputs }`}>
                                <input type="text" placeholder="نام خانوادگی" name="lastNameReceiver" onChange={elementBackgroundColorChanger} />
                            </div>

                            <div className={`col-5 ${ Styled.InputsFrame, Styled.FullNameInputs }`}>
                                <input type="number" value={ageValue} onChange={handleAgeValue} min={0} max={100} name="AgeReceiver" placeholder="سن خود را وارد کنید" />
                            </div>

                            <div className={`col-5 ${ Styled.InputsFrame, Styled.FullNameInputs }`}>
                                <input type="text" placeholder="تلفن همراه (اجباری)" name="phoneNumberReceiver" onChange={elementBackgroundColorChanger} style={{ direction: 'ltr', textAlign: 'left' }} />
                            </div>

                            <div className={`col-11 ${ Styled.InputsFrame }`}>
                                <select name="GenderReceiver" onChange={elementBackgroundColorChanger}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- جنسیت خود را انتخاب کنید --</option>
                                    <option value="MR">آقا</option>
                                    <option value="MRS">خانم</option>
                                </select>
                            </div>

                            <div className={`col-5 ${ Styled.SelectsInputsFrame }`}>
                                <select name="MaritalStatusReceiver" className={ Styled.DubleBox } onChange={(e) => {
                                    haveChildStatusChanger(e);
                                    elementBackgroundColorChanger(e);
                                }}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- وضعیت تاهل خود را انتخاب کنید --</option>
                                    <option value="SINGLE">مجرد</option>
                                    <option value="MARRIED">متاهل</option>
                                    <option value="DIVORCED">مطلقه</option>
                                    <option value="WIDOWED">بیوه</option>
                                </select>
                            </div>
                            <div className={`col-5 ${ Styled.SelectsInputsFrame }`}>
                                <select name="HaveChildReceiver" className={ Styled.DubleBox } onChange={elementBackgroundColorChanger}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- دارای فرزند --</option>
                                    <option value="true">دارای فرزند</option>
                                    <option value="false">بدون فرزند</option>
                                </select>
                            </div>

                            <div className="col-12"></div>

                            <div className={`col-5 ${ Styled.SelectsInputsFrame }`}>
                                <select name="HaveRijectedVisaReceiver" className={ Styled.DubleBox } onChange={elementBackgroundColorChanger}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- آیا در طول ۵ سال اخیر از حوزه شنگن ریجکت شده اید --</option>
                                    <option value="true">بلی</option>
                                    <option value="false">خیر</option>
                                </select>
                            </div>
                            <div className={`col-5 ${ Styled.SelectsInputsFrame }`}>
                                <select name="HaveRecivedVisaReceiver" className={ Styled.DubleBox } onChange={elementBackgroundColorChanger}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- آیا در طول ۳ سال اخیر ویزای شنگن دریافت کرده اید --</option>
                                    <option value="true">بلی</option>
                                    <option value="false">خیر</option>
                                </select>
                            </div>

                            <div className={`col-5 ${ Styled.SelectsInputsFrame }`}>
                                <select name="AlreadyJobsReceiver" className={ Styled.DubleBox } onChange={elementBackgroundColorChanger}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- شغل فعلی خود را انتخاب کنید --</option>
                                    <option value="0">کارمند</option>
                                    <option value="1">کارگر</option>
                                    <option value="2">پزشک</option>
                                    <option value="3">پرستار</option>
                                    <option value="4">تولید کننده</option>
                                    <option value="5">مدیر واحد خدماتی</option>
                                    <option value="6">بازنشسته</option>
                                    <option value="7">بیکار</option>
                                    <option value="8">دانشجو</option>
                                    <option value="9">وکیل</option>
                                    <option value="10">مهندس</option>
                                    <option style={{ direction: 'rtl' }} value="11">پروانه کسب درجه ۱ شامل جواهر و طلا فروشی - آهن فروشی - هتل دار - رستوران - فرش فروشی و ... </option>
                                    <option style={{ direction: 'rtl' }} value="12">پروانه کسب درجه ۲ شامل فروشگاه پوشاک - آرایشگر - فروشگاه لوازم خانگی و ... </option>
                                    <option style={{ direction: 'rtl' }} value="13">پروانه کسب درجه ۳ شامل مشاغل خانگی و ... </option>
                                </select>
                            </div>

                            <div className={`col-5 ${ Styled.SelectsInputsFrame }`}>
                                <select name="InsuranceHistoryReceiver" className={ Styled.DubleBox } onChange={elementBackgroundColorChanger}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- آیا سابقه بیمه تامین اجتمایی متناسب شغل خود دارید --</option>
                                    <option value="true">بلی</option>
                                    <option value="false">خیر</option>
                                </select>
                            </div>

                            <div className={`col-11 ${ Styled.InputsFrame }`}>
                                <select name="BankBalanceReceiver" onChange={elementBackgroundColorChanger}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- میزان موجودی حساب بانکی شما جهت اراـٔه به سفارت تومان --</option>
                                    <option value="204000000">از 0 تا 204 میلیون تومان</option>
                                    <option value="800000000">از 204 تا 800 میلیون تومان</option>
                                    <option value="1150000000">از 800 تا 1 میلیارد و 150 میلیون تومان</option>
                                    <option value="1500220000">از 1 میلیارد و 150 میلیون تا 1.5 میلیارد تومان</option>
                                    <option value="2200300000">از 1.5 میلیارد تا 2.2 میلیارد تومان</option>
                                    <option value="3000400000">از 2.2 میلیارد تا 3 میلیارد تومان</option>
                                    <option value="4000500000">از 3 میلیارد تا 4 میلیارد تومان</option>
                                    <option value="5000700000">از 4 میلیارد تا 5 میلیارد تومان</option>
                                    <option value="7000000000">از 5 میلیارد تا 7 میلیارد تومان</option>
                                    <option value="9000000000">بالای 7 میلیارد تومان</option>
                                </select>
                                
                                {/* <RialInput value={price} onChange={setPrice} /> */}
                            </div>

                            <div className={`col-11 ${ Styled.InputsFrame }`}>
                                <select name="TripTypeReceiver" onChange={elementBackgroundColorChanger}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- به چه صورتی قصد سفر دارید --</option>
                                    <option value="0">مجرد سفر میکنم</option>
                                    <option value="1">متاهل با همسرم سفر میکنم</option>
                                    <option value="2">متاهل بدون همسرم سفر میکنم</option>
                                    <option value="3">متاهل و دارای فرزند با همسر و فرزندم سفر میکنم</option>
                                    <option value="4">متاهل و دارای همسر و فرزند، بدون همسر با فرزندم سفر میکنم</option>
                                    <option value="5">متاهل و دارای همسر و فرزند، با همسر بدون فرزندم سفر میکنم</option>
                                    <option value="6">متاهل و دارای فرزند بدون همسر و فرزندم سفر میکنم</option>
                                    <option value="7">مطلقه یا بیوه بدون فرزند به تنهایی سفر میکنم</option>
                                    <option value="8">مطلقه یا بیوه دارای فرزند با فرزندم سفر میکنم</option>
                                </select>
                            </div>

                            <div className={`col-11 ${ Styled.InputsFrame }`}>
                                <select name="RequestedVisaTypeReceiver" onChange={invitaionStatusChanger}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- نوع ویزای درخواستی شما --</option>
                                    <option value="0">توریستی</option>
                                    <option value="1">تجاری</option>
                                    {/* <option value="2">(تیکت نمایشگاهی)تجاری </option> */}
                                </select>
                            </div>

                            <div className={`col-11 ${ Styled.InputsFrame }`}>
                                <select name="HaveBusinessInvitationReceiver" onChange={elementBackgroundColorChanger} style={{ display: 'none' }}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- آیا دعوت نامه تجاری معتبر دارید --</option>
                                    <option value="true">دارم</option>
                                    <option value="false">ندارم</option>
                                </select>
                            </div>

                            <div className={`col-11 ${ Styled.InputsFrame }`}>
                                <select name="HaveTouristInvitationReceiver" onChange={elementBackgroundColorChanger} style={{ display: 'none' }}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- آیا دعوت نامه توریستی معتبر دارید --</option>
                                    <option value="true">دارم</option>
                                    <option value="false">ندارم</option>
                                </select>
                            </div>

                            <div className={`col-11 ${ Styled.InputsFrame }`}>
                                <select name="DestinationCountryReceiver" onChange={elementBackgroundColorChanger}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- قصد سفر به کدام کشور حوزه شنگن را دارید --</option>
                                    <option value="0">اتریش</option>
                                    <option value="1">بلژیک</option>
                                    <option value="2">دانمارک</option>
                                    <option value="3">فنلاند</option>
                                    <option value="4">فرانسه</option>
                                    <option value="5">آلمان</option>
                                    <option value="6">یونان</option>
                                    <option value="7">مجارستان</option>
                                    <option value="8">ایتالیا</option>
                                    <option value="9">هلند</option>
                                    <option value="10">نروژ</option>
                                    <option value="11">پرتقال</option>
                                    <option value="12">کرواسی</option>
                                    <option value="13">اسپانیا</option>
                                    <option value="14">سوـٔد</option>
                                    <option value="15">سوـٔیس</option>
                                    <option value="16">چک</option>
                                </select>
                            </div>

                            <div className={`col-11 ${ Styled.InputsFrame }`}>
                                <select name="AlreadyCityReceiver" onChange={elementBackgroundColorChanger}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- ساکن چه استانی در ایران هستید --</option>
                                    <option value="0">استان آ.غ</option>
                                    <option value="1">استان آ.ش</option>
                                    <option value="2">استان اردبیل</option>
                                    <option value="3">استان زنجان</option>
                                    <option value="4">استان قزوین</option>
                                    <option value="5">استان تهران</option>
                                    <option value="6">استان کردستان</option>
                                    <option value="7">استان کرمانشاه</option>
                                    <option value="8">استان همدان</option>
                                    <option value="9">استان گیلان</option>
                                    <option value="10">استان مازندران</option>
                                    <option value="11">استان خراسان رضوی</option>
                                    <option value="12">استان قم</option>
                                    <option value="13">استان سیستان و بلوچستان</option>
                                    <option value="14">استان هرمزگان</option>
                                    <option value="15">استان خوزستان</option>
                                    <option value="16">استان ایلام</option>
                                    <option value="17">استان اصفهان</option>
                                    <option value="18">استان فارس</option>
                                    <option value="19">استان یزد</option>
                                    <option value="20">استان مرکزی</option>
                                    <option value="21">استان کیش</option>
                                    <option value="22">قم</option>
                                    <option value="23">استان البرز</option>
                                </select>
                            </div>

                            <div className={`col-11 ${ Styled.InputsFrame }`}>
                                <select name="HaveHomeReceiver" onChange={elementBackgroundColorChanger}>
                                    <option value="" disabled selected className={ Styled.FirstOptionColor }>-- آیا املاکی به نام خود دارید --</option>
                                    <option value="true">بلی</option>
                                    <option value="false">خیر</option>
                                </select>
                            </div>

                            <div className={`col-11 ${ Styled.InputsFrame }`}>
                                <button onClick={ VisaAssessor }>محاسبه</button>
                                
                                <br /><br />
                            </div>
                        </div>
                    </>
                )
            }

            <Fotter />
        </>
    );
}

export default MainPage;
